import React from 'react';
import { Switch, Route } from 'react-router';
import PropTypes from 'prop-types';
import { ui } from 'components';
import { compose, withStateHandlers } from 'recompose';
import * as scenes from 'scenes';

import 'assets/screens.scss';
import './style.scss';

const HomeScene = ({
  cart,
  addProduct,
  deleteProduct,
  removeCart,
  history,
}) => (
  <ui.Layout currentRoute={history.location.pathname} cart={cart}>
    <Switch>
      <Route
        path="/cart"
        render={props =>
          <scenes.CartScene
            cart={cart}
            addProduct={addProduct}
            deleteProduct={deleteProduct}
            removeCart={removeCart}
            {...props}
          />
        }
      />
      <Route path="/delivery" component={scenes.DeliveryScene} />
      <Route
        path="/product/:productId"
        render={props =>
          <scenes.ProductScene addProduct={addProduct} {...props} />
        }
      />
      <Route
        path="/checkout"
        render={props =>
          <scenes.CheckoutScene removeCart={removeCart} cart={cart} {...props} />
        }
      />
      <Route path="/addproduct" component={scenes.AddProductScene} />
      <Route path="/contacts" component={scenes.ContactsScene} />
      <Route path="/catalog" component={scenes.CatalogScene} />
      <Route path="/" component={scenes.FrontScene} />
    </Switch>
  </ui.Layout>
);

HomeScene.propTypes = {
  deleteProduct: PropTypes.func.isRequired,
  addProduct: PropTypes.func.isRequired,
  removeCart: PropTypes.func.isRequired,
  history: PropTypes.object,

  cart: PropTypes.shape({
    quantity: PropTypes.number.isRequired,
    sum: PropTypes.number.isRequired,
  }).isRequired,
};

// difficult logic
// when product is added - item id = product id, size and color required too
// when product is deleted - item id = id + size + color, size and color are getting from old item
// problem with price (currently is saved in localStorage for each item, not getting from server)
// when item price is changed on server, user can see old price in cart
export default compose(
  withStateHandlers(
    ({
       cart = localStorage.getItem('cart') ?
         JSON.parse(localStorage.getItem('cart')).cart :
         {
           quantity: 0,
           sum: 0,
         },
     }) => ({
      cart,
    }),
    {
      addProduct: ({ cart }) => ({
        id,
        color,
        size,
        price = cart[`${id}_${size}_${color}`].price,
        count = 1,
      }) => {
        cart = localStorage.getItem('cart') ?
          JSON.parse(localStorage.getItem('cart')).cart : cart;

        console.log(localStorage.getItem('cart'), cart, id, count);

        const newCart = {
          cart: {
            ...cart,
            quantity: cart.quantity + count,
            sum: cart.sum + (count * price),
            [`${id}_${size}_${color}`]: {
              id,
              count: (cart[`${id}_${size}_${color}`] ? cart[`${id}_${size}_${color}`].count : 0) + count,
              price,
              size,
              color,
            },
          },
        };

        localStorage.setItem('cart', JSON.stringify(newCart));
        return newCart;
      },
      deleteProduct: ({ cart }) => ({ id, count }) => { // id = item_id + size + color
        cart = localStorage.getItem('cart') ?
          JSON.parse(localStorage.getItem('cart')).cart : cart;

        if (!cart[id]) return cart;

        let newCart;

        console.log(cart, id, count);
        if (count === undefined || cart[id].count - count === 0) {
          newCart = {
            cart: {
              ...cart,
              quantity: cart.quantity - cart[id].count,
              sum: cart.sum - (cart[id].count * cart[id].price),
              [id]: undefined,
            },
          };
        } else {
          newCart = {
            cart: {
              ...cart,
              quantity: cart.quantity - count,
              sum: cart.sum - (count * cart[id].price),
              [id]: {
                id: cart[id].id,
                count: cart[id].count - 1,
                price: cart[id].price,
                size: cart[id].size,
                color: cart[id].color,
              },
            },
          };
        }

        localStorage.setItem('cart', JSON.stringify(newCart));
        return newCart;
      },
      removeCart: () => () => {
        localStorage.removeItem('cart');
        return {
          cart: {
            quantity: 0,
            sum: 0,
          },
        };
      },
    },
  ),
)(HomeScene);



// WEBPACK FOOTER //
// ./src/scenes/HomeScene/index.js